import OssService from './ossSTSService';
import HttpLocal from './httpLocal';
import BaseApi from './lib/baseApi';
import BaseStorage from './lib/baseStorage';
import BaseEnv from './lib/baseEnv';
import BaseService from './lib/baseService';

class API extends BaseApi {
  constructor() {
    super();
    // api接口地址
    this.service = new BaseService();
    // oss文件上传
    this.ossService = new OssService();
    // 本地存储
    this.storage = new BaseStorage();
    // 环境变量
    this.env = new BaseEnv();
    // 本地json数据
    this.localJson = new HttpLocal();
  }
}

export default {
  install(Vue) {
    if (this.installed) return;
    this.installed = true;
    Vue.api = Vue.prototype.api = new API();
    //将api属性设置为不可写，为了防止某些插件冲突
    Object.defineProperty(Vue, 'api', {
      configurable: false, // 不可删除
      writable: false, // 不可写
    });
    Object.defineProperty(Vue.prototype, 'api', {
      configurable: false, // 不可删除
      writable: false, // 不可写
    });
  },
};
